<template>
    <div class="fileupload">
        <div class="columns is-mobile">
            <div class="column">
                <form enctype="multipart/form-data" novalidate>
                    <div class="dropbox">
                        <input type="file" multiple :name="uploadFieldName" :disabled="currentStatus === 'saving'" @change="filesChange($event, $event.target.files); fileCount = $event.target.files.length" class="input-file">
                        <p v-if="currentStatus === 'ready'">
                            <!-- <FileuploadLogo /> -->
                            <icon class="upload" name="upload"></icon><br />
                            <span class="header">{{ $t('chooseFile')}}</span>
                        </p>
                        <p v-if="currentStatus === 'saving'" class="align-text-center uploading">
                            {{ $t('uploading') }} {{ fileCount }} {{ $t('files') }}
                        </p>
                        <p v-if="currentStatus === 'failed'" class="align-text-center" style="margin-top: -10px;">
                            {{ $t('uploadFailed') }} <br />
                            {{ $t('tryAgain') }}
                        </p>
                        <p v-if="currentStatus === 'wrong'" class="align-text-center" style="margin-top: 0px;">
                            {{ $t('uploadFiletype') }}
                        </p>
                    </div>
                </form>
                <form enctype="multipart/form-data" novalidate>
                    <div class="dropbox">
                        <input type="file" accept="image/*" capture="camera" multiple name="image" :disabled="currentStatus === 'saving'" @change="filesChange($event, $event.target.files); fileCount = $event.target.files.length" class="input-file">
                        <p v-if="currentStatus === 'ready'">
                            <!-- <FileuploadLogo /> -->
                            <icon class="camera" name="camera"></icon><br />
                            <span class="header">{{ $t('uploadPhoto')}}</span>
                        </p>
                        <p v-if="currentStatus === 'saving'" class="align-text-center uploading">
                            {{ $t('uploading') }} {{ fileCount }} {{ $t('files') }}
                        </p>
                        <p v-if="currentStatus === 'failed'" class="align-text-center" style="margin-top: -10px;">
                            {{ $t('uploadFailed') }} <br />
                            {{ $t('tryAgain') }}
                        </p>
                        <p v-if="currentStatus === 'wrong'" class="align-text-center" style="margin-top: 0px;">
                            {{ $t('uploadFiletype') }}
                        </p>
                    </div>
                </form>
            </div>
        </div>

        <!--SUCCESS -->
        <div class="columns is-multiline is-mobile">
            <div v-if="uploadedFiles.length > 0" class="column is-6 upload-item" v-for="(item, index) in uploadedFiles" v-bind:key="index">
                <span class="remove-item" @click="handleRemove(item, index)">×</span>
                <span v-if="item.caption && item.caption !== ''" class="added-comment truncate-fade-small">
                    <icon class="smaller-svg" name="comment"></icon>
                    {{item.caption}}
                </span>
                <a v-if="item.dataSource" class="img-container" @click="handleShow(item, index)" :style="{ 'background': 'url(' + item.dataSource + ')'}"></a>
            </div>
        </div>

        <!-- modal -->
        <custom-modal v-if="showModal && !modalComponent" @close="closeModal">
            <div slot="body">
                <div v-if="removeImageBool">
                    <h3>{{ $t('removeImageHeader') }}</h3>
                    <p>{{ $t('removeImageText') }}</p>
                    <div class="img-container" style="height: 280px;" :style="{ 'background': 'url(' + showRemoveImage + ')'}"></div>
                    <div class="modal-bottombar">
                        <div class="buttons-modal text-center">
                            <a @click="removeItem()">{{ $t('remove') }}</a>
                            <a @click="closeModal()">{{ $t('cancel') }}</a>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <h3>{{ $t('editImageHeader')}}</h3>
                    <img class="image-modal" :src="showRemoveImage">
                    <!-- <div class="img-container" style="height: 280px;" :style="{ 'background': 'url(' + showRemoveImage + ')'}"></div> -->
                    <div class="columns is-mobile comment-section">
                        <div class="column is-9 column-no-padding">
                            <input type="text" :placeholder="$t('comment')" v-model="imageComment">
                        </div>
                        <div class="column column-no-padding flexbox-center-right">
                            <a class="button custom-check-a" @click="addComment()">
                                <icon class="small-svg" name="check"></icon>
                            </a>
                        </div>
                    </div>
                    <div class="comment">
                        <p v-show="showImageCaption !== ''" class="comment-margin">
                            <b>{{ $t('comment') }}</b>
                            <span class="comment-icon" @click="editComment()">
                                <icon class="small-svg" name="edit"></icon>
                            </span>
                            <span class="comment-icon" @click="removeComment()">
                                <icon class="small-svg" name="remove"></icon>
                            </span>
                        </p>
                        <p v-show="showImageCaption !== ''" class="italic">{{showImageCaption}}</p>
                    </div>
                    <div class="modal-bottombar">
                        <div class="buttons-modal text-center">
                            <a @click="closeModal()">{{ $t('close') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </custom-modal>
    </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex'
import upload from './../../../mixins/shared/fileuploadHandler'
import customModal from './../modal/custom-modal'
const getOrientedImage = require('exif-orientation-image')
// import FileuploadLogo from "@/assets/svg/upload.svg";
// require('lightbox2/dist/css/lightbox.css')
// require('lightbox2')

const mongoObjectId = () => {
    let timestamp = (new Date().getTime() / 1000 | 0).toString(16)
    return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
        return (Math.random() * 16 | 0).toString(16)
    }).toLowerCase()
}

export default {
    name: 'fileupload',
    mixins: [upload],
    props: ['modalComponent', 'repeater', 'userAction'],
    components: {
        'custom-modal': customModal
        // FileuploadLogo
    },
    data () {
        return {
            uploadError: null,
            currentStatus: 'ready',
            fileCount: null,
            uploadFieldName: 'file',
            wrongFileType: false,
            visible: false,
            showModal: false,
            imageSource: null,
            removeImageObj: {},
            removeImageBool: false,
            imageComment: ''
        }
    },
    computed: {
        ...mapGetters({
            user: 'getUserData',
            uploadedImages: 'getImages',
            uploadedImagesOnRepeater: 'getImagesOnRepeater',
            activeRegistration: 'getActiveRegistration',
            activeRepeaterRegistration: 'getActiveRepeaterRegistration'
        }),
        uploadedFiles () {
            if (this.repeater) {
                return this.uploadedImagesOnRepeater
            } else {
                // console.log(Array.isArray(this.uploadedImages)
                if (!this.uploadedImages.length > 0) {
                    console.log('!this.uploadedFiles: ', true)
                    // SKAL FIXES MÅSKE?
                    // this.attachUploadsToActiveRegistration(this.activeRegistration)
                }
                return this.uploadedImages
            }
        },
        showImageCaption () {
            let caption = null
            this.uploadedFiles.forEach(el => {
                if (el.selected) {
                    caption = el.caption
                }
            })
            return caption
        },
        showRemoveImage () {
            let dataSource = null
            this.uploadedFiles.forEach(el => {
                if (el.selected) {
                    dataSource = el.dataSource
                }
            })
            return dataSource
        }
    },
    methods: {
        ...mapActions({
            addImage: 'addImage',
            removeImage: 'removeImage',
            setCaptionImage: 'setCaptionImage',
            // attachUploadsToActiveRegistration: 'attachUploadsToActiveRegistration',
            addImageOnRepeater: 'addImageOnRepeater',
            addUploadToActiveRegistration: 'addUploadToActiveRegistration',
            removeImageFromRepeater: 'removeImageFromRepeater',
            toggleModal: 'toggleModal',
            getPhotosFromExistingRegistration: 'getPhotosFromExistingRegistration',
            getRepeaterPhotosFromExistingRegistration: 'getRepeaterPhotosFromExistingRegistration'
        }),
        closeModal () {
            this.uploadedFiles.forEach((el) => {
                if (el.selected) {
                    el.selected = false
                }
            })
            this.toggleModal(false)
            this.showModal = false
        },
        reset () {
            this.currentStatus = 'ready'
            this.uploadError = null
        },
        save (obj) {
            const _this = this
            this.currentStatus = 'saving'
            this.upload(obj)
                .then(this.wait(1500))
                .then(x => {
                    this.wrongFileType = false
                    let filetype = x.dataType
                    console.log('filetype', filetype)
                    switch (filetype) {
                    case 'image/png':
                        let uli = URL.createObjectURL(obj.file)
                        return new Promise((resolve, reject) => {
                            resolve(uli)
                        })
                    case 'image/jpeg':
                        console.log('obj.file:', obj.file)
                        let uliJpg = URL.createObjectURL(obj.file)
                        return new Promise((resolve, reject) => {
                            resolve(uliJpg)
                        })
                    default:
                        console.log('none of the above')
                        this.wrongFileType = true
                        return false
                    }
                }).then((response) => {
                    if (!this.wrongFileType) {
                        let blob = null
                        return new Promise((resolve, reject) => {
                            getOrientedImage(obj.file, function (err, canvas) {
                                if (!err) {
                                    canvas.toBlob(function (blob) {
                                        resolve(blob)
                                    }, obj.file.type, 1)
                                }
                            })
                        }).then((orientedImageBlob) => {
                            blob = orientedImageBlob
                            response = URL.createObjectURL(blob)
                        }).then(() => {
                            let reader = new FileReader()
                            let randomNamePart = mongoObjectId()
                            reader.readAsArrayBuffer(obj.file)
                            reader.onload = function (theFile) {
                                let upload = {
                                    caption: null,
                                    createdDateTime: "0001-01-01T00:00:00",
                                    fileName: null,
                                    filePath: 'CustomerData/' + _this.user.customerId + '/FormRegistrations/',
                                    fileUri: null,
                                    imageResized: null,
                                    latitude: 0,
                                    longitude: 0,
                                    tags: [],
                                    uploadId: ''
                                }
    
                                upload.uploadId = randomNamePart
                                upload.fileName = randomNamePart + obj.file.name
                                upload.filePath = upload.filePath + _this.activeRegistration.formRegistrationId
                                upload.createdDateTime = new Date().toISOString()
                                upload.caption = ''
    
                                // Add to state.activeRegistration.uploads
                                // SKAL FIXES PÅ ET TIDSPUNKT
                                if (!_this.repeater) {
                                    _this.addUploadToActiveRegistration(upload)
                                }                                                     
    
                                // Add image to Vuex
                                let outboxImgObj = {
                                    'id': randomNamePart,
                                    'thumb': '', // arrayBuffer
                                    'data': reader.result,
                                    'type': obj.file.type,
                                    'state': 'saved',
                                    'fileName': randomNamePart + obj.file.name,
                                    'filePath': 'CustomerData\\' + _this.user.customerId + '\\FormRegistrations\\' + (_this.activeRepeaterRegistration && _this.activeRepeaterRegistration.formRegistrationId ? _this.activeRepeaterRegistration && _this.activeRepeaterRegistration.formRegistrationId : _this.activeRegistration.formRegistrationId),
                                    'dataSource': response,
                                    'name': obj.file.name,
                                    'selected': false,
                                    'file': obj.file,
                                    'caption': '',
                                    'registrationId': _this.activeRepeaterRegistration && _this.activeRepeaterRegistration.formRegistrationId ? _this.activeRepeaterRegistration.formRegistrationId : _this.activeRegistration.formRegistrationId,
                                    
                                    //PLA: This is NOT the repeaterRegistrationId - it is wrong and unused - I think
                                    'repeaterRegistrationId': _this.activeRepeaterRegistration && _this.activeRepeaterRegistration.repeaterId ? _this.activeRepeaterRegistration.repeaterId : ""
                                }
                                if (_this.repeater) {
                                    console.log('Uploading repeaterimage: ', outboxImgObj);
                                    _this.addImageOnRepeater(outboxImgObj)
                                } else {
                                    console.log('Uploading image: ', outboxImgObj);
                                    _this.addImage(outboxImgObj)
                                }
                                _this.currentStatus = 'ready'
                            }
                        })

                    } else {
                        console.log('error', this.uploadError)
                        this.currentStatus = 'wrong'
                        setTimeout(() => {
                            this.currentStatus = 'ready'
                        }, 3000)
                    }
                }).catch(err => {
                    this.uploadError = err
                    console.log('error', this.uploadError)
                    this.currentStatus = 'failed'
                })
        },
        filesChange ($event, files) {
            if (!files.length) {
                return
            }
            Array
                .from(Array(files.length).keys())
                .map(x => {
                    let obj = {
                        data: new FormData(),
                        dataType: files[x].type,
                        file: files[x]
                    }
                    obj.data.append('content', files[x], files[x].name)
                    this.save(obj)
                })
        },
        wait (ms) {
            return (x) => {
                return new Promise(resolve => setTimeout(() => resolve(x), ms))
            }
        },
        handleRemove (item, idx) {
            let object = {
                item: item,
                index: idx
            }
            if (!this.modalComponent) {
                this.uploadedFiles.forEach((el, index) => {
                    if (idx === index) {
                        el.selected = true
                    }
                })
                this.removeImageBool = true
                this.showModal = true
                this.toggleModal(true)
            } else {
                URL.revokeObjectURL(object.item.dataSource)
                this.removeImageFromRepeater(object)
            }
        },
        handleShow (item, idx) {
            console.log('handleShow')
            this.removeImageBool = false
            // let object = {
            //     item: item,
            //     index: idx
            // }
            if (!this.modalComponent) {
                this.uploadedFiles.forEach((el, index) => {
                    if (idx === index) {
                        el.selected = true
                    }
                })
                this.showModal = true
                this.toggleModal(true)
            } else {
                console.log('else???')
            }
        },
        removeItem () {
            let object = {
                item: '',
                index: ''
            }
            this.uploadedFiles.forEach((el, index) => {
                if (el.selected) {
                    object.item = el
                    object.index = index
                }
            })
            URL.revokeObjectURL(object.item.dataSource)
            this.removeImage(object)
            this.toggleModal(false)
            this.showModal = false
        },
        addComment () {
            this.uploadedFiles.forEach((el, index) => {
                if (el.selected) {
                    this.setCaptionImage(el)
                    el.caption = this.imageComment
                    this.imageComment = ''
                }
            })
        },
        editComment () {
            this.uploadedFiles.forEach((el, index) => {
                if (el.selected) {
                    this.imageComment = el.caption
                }
            })
        },
        removeComment () {
            this.uploadedFiles.forEach((el, index) => {
                if (el.selected) {
                    el.caption = ''
                }
            })
        }
    },
    filters: {
        truncate (text) {
            return text.slice(0, 22) + (text.length > 22 ? '' || '...' : '')
        }
    },
    mounted () {
        this.reset()
    },
    created () {
        const _this = this
        if (this.userAction === 'update') {
            return new Promise((resolve, reject) => {
                if (!this.repeater) {
                    resolve(_this.getPhotosFromExistingRegistration(_this.activeRegistration.formRegistrationId))
                } else {
                    resolve(_this.getRepeaterPhotosFromExistingRegistration(_this.activeRepeaterRegistration.repeaterRegistrationId))
                }
            }).then(() => {
                return new Promise((resolve, reject) => {
                    let promises = []
                    if (_this.uploadedFiles.length > 0) {
                        _this.uploadedFiles.forEach((image) => {
                            switch (image.type) {
                            case 'image/png':
                                promises.push(new Promise((resolve, reject) => {
                                    let uli = URL.createObjectURL(image.file)
                                    resolve(uli)
                                }))
                                break
                            case 'image/jpeg':
                                promises.push(new Promise((resolve, reject) => {
                                    let uliJpg = URL.createObjectURL(image.file)
                                    resolve(uliJpg)
                                }))
                                break
                            }
                        })
                        return Promise.all(promises).then(response => resolve(response))
                    } else {
                        return resolve()
                    }
                })
            }).then((response) => {
                if (response) {
                    _this.uploadedFiles.forEach((image, index) => {
                        image.dataSource = response[index]
                        image.filePath = response[index]
                    })
                }
            })
        }
    }
}
</script>
